import React, { memo, Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';

const SvgFormat = props => {
  const { type, ...restProps } = props;
  const svgType = upperFirst(camelCase(type));

  const SvgComponents = lazy(() =>
    import(`../components/svgs/${svgType}`).catch(error => {
      console.error(`Failed to load SVG component for type: ${svgType}`, error);
      return { default: () => <div>Error loading SVG</div> };
    }),
  );

  return (
    <Suspense fallback="">
      <SvgComponents {...restProps} />
    </Suspense>
  );
};

SvgFormat.propTypes = {
  type: PropTypes.string.isRequired,
};

export default memo(SvgFormat);
